import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConstantService } from 'src/app/service/constant.service';
import { GamesService } from 'src/app/service/games.service';
import { DomSanitizer } from '@angular/platform-browser';
import SwiperCore, { Navigation, SwiperOptions } from 'swiper/core';
import { TranslateService } from '@ngx-translate/core';
export enum fiterTypes { All, LiveGame, VirtualGame, PowerGame };
SwiperCore.use([Navigation]);

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.styl']
})
export class WidgetComponent implements OnInit {
  // IsVerified = false;
  IsCallMade = false;
  ShowGameList = false;
  IsReload = false;
  isLoading = true;
  Token = '';
  Code = '';
  UserName = 'User';
  GameLiability = 0;
  vacuumeGameList: any[] = [];
  DisplayMessage: any = '';
  selectedfiterType = fiterTypes.All;
  fiterType = fiterTypes;
  loader = 'assets/images/logo/supernowa-logo.png';
  widgetGameList = [];
  config: SwiperOptions = {
    // pagination: { el: '.swiper-pagination', clickable: true },
    autoHeight: true,
    allowTouchMove: true,
    hashNavigation: true,
    breakpoints: {
      1024: {
        slidesPerView: 8
      },
      500: {
        slidesPerView: 3
      },
      400: {
        slidesPerView: 2
      },
      300: {
        slidesPerView: 2
      }
    },
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev'
    // },
    loop: true,
    initialSlide: 0
  };

  gameUrl = '';
  public _secureHtml: any = '';
  @Output() GameUrl = new EventEmitter();
  GameCode = '';
  // hubConnection = new HubConnectionModel();
  constructor(
    private gamesService: GamesService
    , public constant: ConstantService
    , private router: Router
    , private toastr: ToastrService,
    private domSanitizer: DomSanitizer,
    public translateService:TranslateService
  ) {
    this.gameUrl = sessionStorage.getItem('widGetGameUrl') ? sessionStorage.getItem('widGetGameUrl') : '';
  }

  ngOnInit(): void {

    const listData = sessionStorage.getItem('GameList') ? JSON.parse(sessionStorage.getItem('GameList')) : [];
    this.widgetGameList = listData.length > 0 ? listData.filter(item => item.GameCode.trim() === 'TP' || item.GameCode.trim() === 'DP') : [];
    this.constant.newsList = [];
    this.constant.gameId = 0;
    sessionStorage.removeItem('GameId');
    const LoginLink = sessionStorage.getItem('LoginLink');
    sessionStorage.setItem('LoginLink', LoginLink);
    const url = new URL(window.location.href);
    const Token = url.searchParams.get('Token');
    if (Token && Token !== '') {
      this.Token = Token;
      if (this.gameUrl != '') {
        this.redirectGame();
      }
      else {
        if (this.widgetGameList.length > 0) {
          let getGameDetail: any = this.widgetGameList[0];
          this.getGameUrl(getGameDetail, 0);
        }
      }
    } else {
      this.constant.IsVerified = false;
      this.DisplayMessage = this.translateService.instant('Invalid Token. Please Login Again');
    }
  }


  gameFilterList(type: fiterTypes) {
    this.selectedfiterType = type;
    // this.tmpGameList = this.gameList;
    this.constant.tmpGameList = this.constant.gameList.filter(x => x.GameType === this.fiterType[this.selectedfiterType] || this.selectedfiterType === this.fiterType.All);
  }

  // async NavigatoToGame(item) {
  //   if (item.GameType === 'PowerGame') {
  //     // this.vacuumLogin(item.GameCode)
  //   } else {
  //     sessionStorage.setItem('GameUrl', JSON.stringify(item.GameUrl));
  //     sessionStorage.setItem('GameId', JSON.stringify(item.GameID));
  //     sessionStorage.setItem('GameName', JSON.stringify(item.Name));
  //     this.constant.gameName = item.Name;
  //     this.router.navigate(['/games']);
  //   }
  // }

  getGameUrl(item, index) {
    this.setCurrentSlider(index);
    this.GameCode = 'W' + item.GameCode.trim();
    if (this.GameCode === 'WTP') {
      item.GameUrl = item.GameUrl.replace('/TP', '/WTP');
    }
    else if (this.GameCode === 'WDT') {
      item.GameUrl = item.GameUrl.replace('/DT', '/WDT');
    }
    this.constant.gameId = item.GameID;
    sessionStorage.setItem('widGetGameIndex', index);
    sessionStorage.setItem('widGetGameName', JSON.stringify(item.Name));
    this.constant.gameName = item.Name;

    sessionStorage.setItem('widGetGameUrl', item.GameUrl);
    setTimeout(() => {
      this._secureHtml = this.domSanitizer.bypassSecurityTrustResourceUrl(item.GameUrl);
    }, 0);
  }
  private setCurrentSlider(index) {
    if (index !== 0) {
      this.config.initialSlide = index - 2;
    } else {
      this.config.initialSlide = index;
    }
  }
  get transform() {
    if (this._secureHtml) {
      return this._secureHtml;
    } else {
      return '';
    }
  }

  redirectGame() {
    if (this.gameUrl) {
      this.GameCode = this.gameUrl ? new URL(this.gameUrl).pathname.replace('/', '') : '';
      this._secureHtml = this.domSanitizer.bypassSecurityTrustResourceUrl(this.gameUrl);
      const index = sessionStorage.getItem('widGetGameIndex');
      if (index) {
        this.setCurrentSlider(index)
      }
    }
  }
}
